/* =========================================================================

 Project: Socjomania.pl
 Last updated: @@timestamp

 ========================================================================= */

(function ( $ ) {
  "use strict";

  var Socjomania = {
    DOM: {},

    init: function () {
      Socjomania.helpers.cacheDOM();

      Socjomania.menu.init();
      Socjomania.carousels.init();
      Socjomania.opinions.init();
      Socjomania.recommendations.init();
      Socjomania.courses.init();
      Socjomania.trainers.init();
      Socjomania.reveal.init();
      Socjomania.uncover.init();
      Socjomania.scrollTo.init();
      Socjomania.stickyLinks.init();
      Socjomania.autoScroll.init();
      Socjomania.yourTopic.init();
      Socjomania.courseTopBar.init();
      Socjomania.exitPopup.init();
      Socjomania.blog.init();
    },

    helpers: {
      cacheDOM: function () {
        Socjomania.DOM.doc = $( document );
        Socjomania.DOM.win = $( window );
      },

      // ensure things are re-painted before invoking the callback
      afterRedraw: function ( callback ) {
        window.requestAnimationFrame( function () {
          window.requestAnimationFrame( callback );
        } );
      },

      carouFredSel: function ( $root, options ) {
        options = options || {};

        $root.carouFredSel( $.extend( {
          width: '100%',
          height: 'auto',
          swipe: {
            onTouch: Modernizr.touch,
            onMouse: false
          },
          onCreate: function () {
            if ( $( 'html' ).hasClass( 'ie8' ) ) {
              var $section = $( this ).closest( '.caroufredsel_wrapper' ).closest( 'section' );

              $section.height( $section.height() );

              Socjomania.DOM.win
                  .on( 'resize.caroufredsel', $.debounce( 300, function () {
                    $section.height( '' );
                    Socjomania.helpers.afterRedraw( function () {
                      $section.height( $section.height() );
                    } );
                  } ) );
            }
          }
        }, options ), {
          transition: Modernizr.csstransitions && (!options.items || options.items.width !== 'variable'),
          onWindowResize: 'debounce'
        } );
      },

      getTarget: function ( $el, component, defaultVal ) {
        return $el.data( component + '-target' ) || $el.data( 'target' ) || defaultVal;
      },

      afterLoad: function () {
        Socjomania.helpers.afterRedraw( function () {
          Socjomania.uncover.refresh();
          Socjomania.opinions.refresh();
          Socjomania.trainers.refresh();
          Socjomania.underline.init();

          if ( window.ExitPopupConfig ) {
            Socjomania.exitPopup.events.resize();
          }
        } );
      }
    },

    menu: {
      containerSelector: '.menu-button',

      init: function () {
        if ( !Modernizr.touch ) {
          Socjomania.DOM.doc
              .on( 'mouseenter.menu mouseleave.menu', Socjomania.menu.containerSelector, Socjomania.menu.events.hover )
              .on( 'focus.menu', Socjomania.menu.containerSelector, Socjomania.menu.events.focus );
        } else {
          Socjomania.DOM.doc
              .on( 'touchstart.menu', Socjomania.menu.containerSelector, Socjomania.menu.events.touch );
        }
      },

      toggle: function ( $self, toggle ) {
        $self.find( '.menu' ).transitionHelper();
        $self.toggleClass( 'open', toggle );

        Socjomania.DOM.doc
            .off( 'click.menu' );

        if ( toggle === false ) {
          $self
              .removeClass( 'focused' )
              .off( '.menu' )
              .off( '.innermenu' );

          // disable inner nav links - nav is hidden so they only confuse
          $self.find( 'a' ).attr( 'tabindex', -1 );
        } else {
          Socjomania.DOM.doc
              .on( 'click.menu', Socjomania.menu.events.outsideClick );
        }
      },

      events: {
        touch: function ( ev ) {
          Socjomania.menu.toggle( $( this ), !$( ev.target ).closest( 'li' ).length ? undefined : true );
        },

        hover: function ( ev ) {
          var $self = $( this );

          Socjomania.menu.toggle( $self, ev.type === "mouseenter" || $self.hasClass( 'focused' ) );
        },

        focus: function () {
          var $self = $( this );

          // disable inner nav links - nav is hidden so they only confuse
          $self.not( '.open' ).find( 'a' ).attr( 'tabindex', -1 );

          // bind opening via space/enter
          $self
              .off( 'keydown.menu' )
              .on( 'keydown.menu', Socjomania.menu.events.keydown );
        },

        keydown: function ( ev ) {
          var $self = $( this );

          switch ( ev.which ) {
            case 13:
            case 32:
              ev.preventDefault();
              Socjomania.menu.toggle( $self );
              $self.toggleClass( 'focused' );
              // enable inner nav links
              $self.find( 'a' )
                  .removeAttr( 'tabindex' );
              $self
                  .off( 'focus.innermenu keydown.innermenu' )
                  .on( 'focus.innermenu', 'a', Socjomania.menu.events.innerFocus )
                  .on( 'keydown.innermenu', 'a', Socjomania.menu.events.innerKeydown );
              break;
            case 27:
              ev.preventDefault();
              Socjomania.menu.toggle( $self, false );
              break;
            case 9:
              if ( ev.shiftKey ) {
                Socjomania.menu.toggle( $self, false );
              }
              break;
          }
        },

        innerFocus: function () {
          var $menu = $( this ).closest( Socjomania.menu.containerSelector );

          if ( !$menu.has( document.activeElement ).length ) {
            Socjomania.menu.toggle( $menu, false );
          }
        },

        innerKeydown: function ( ev ) {
          if ( ev.which === 9 && !ev.shiftKey && $( this ).closest( 'li' ).is( ':last-child' ) ) {
            Socjomania.menu.toggle( $( this ).closest( Socjomania.menu.containerSelector ), false );
          }
        },

        outsideClick: function ( ev ) {
          if ( !$( ev.target ).closest( Socjomania.menu.containerSelector ).length ) {
            Socjomania.menu.toggle( $( Socjomania.menu.containerSelector ).filter( '.open' ), false );
          }
        }
      }
    },

    carousels: {
      init: function() {

        $('.carousel img').css('position', 'absolute').css('visibility', 'hidden');

        $('.carousel').each(function(_i, carousel) {
          var $carousel = $(carousel);
          $carousel.imagesLoaded(function() {
            $carousel.find('img').css('position', '').css('visibility', '');
            $carousel.carouFredSel({
              height: 'auto',
              items: {
                visible: 1
              },
              swipe: {
                onTouch: Modernizr.touch,
                onMouse: false
              },
              pagination: $('#' + $carousel.attr('id') + '-pagination')
            }, {
              transition: Modernizr.csstransitions
            });

            $carousel.closest('.caroufredsel_wrapper').css('margin','0 auto');
          });
        });

      }
    },

    opinions: {
      init: function () {
        var $slides = $( '.opinions-slides' );

        if ( $slides.length ) {
          Socjomania.helpers.carouFredSel( $slides, {
            auto: false,
            responsive: true,
            items: {
              visible: 1,
              width: 700
            },
            next: '.opinions-next',
            prev: '.opinions-prev',
            pagination: '.opinions-pagination'
          } );
        }
      },

      refresh: function () {
        var $slides = $( '.opinions-slides' );

        $slides.closest( '.caroufredsel_wrapper' ).height( '' );
        $slides.trigger( 'configuration', [ {}, true ] );
      }
    },

    recommendations: {
      init: function () {
        var $slides = $( '.recommendations-slides' );

        if ( $slides.length ) {
          Socjomania.helpers.carouFredSel( $slides, {
            auto: true,
            responsive: false,
            items: {
              visible: 'variable',
              height: 60,
              width: 'variable'
            },
            scroll: {
              items: 1
            }
          } );

          $slides.imagesLoaded( function () {
            $slides.closest( '.caroufredsel_wrapper' ).height( '' );
            $slides.trigger( 'configuration', [ {}, true ] );
          } );
        }
      }
    },

    courses: {
      init: function () {
        Socjomania.DOM.doc
            .off( '.courses' )
            .on( 'click.courses', '.courselist-more a', Socjomania.courses.events.click );
      },

      events: {
        click: function ( ev ) {
          ev.preventDefault();

          var $hidden = $( this ).closest( '.courselist-content' ).find( '.course-grid .course.hidden' );
          var $toShow = $hidden.slice( 0, 3 );

          $toShow.transitionHelper();

          Socjomania.helpers.afterRedraw( function () {
            $toShow.removeClass( 'hidden' );
          } );

          if ( $toShow.length >= $hidden.length ) {
            $( this ).closest( '.courselist-more' ).remove();
          }
        }
      }
    },

    trainers: {
      init: function () {
        var $slides = $( '.trainers-slides' );
        var english = document.body.classList.contains('english');

        if ( $slides.length ) {
          Socjomania.helpers.carouFredSel( $slides, {
            auto: false,
            responsive: true,
            items: {
              visible: {
                min: 1,
                max: english ? 1 : 2
              },
              width: english ? undefined : 600,
              height: 'variable'
            },
            scroll: {
              items: 1,
              pauseOnHover: true
            },
            pagination: '.trainers-pagination'
          } );

          $slides.imagesLoaded( function () {
            Socjomania.helpers.afterRedraw( function () {
              Socjomania.trainers.refresh();
            } );
          } );

          Socjomania.DOM.win
              .off( '.trainers' )
              .on( 'resize.trainers', $.debounce( 300, Socjomania.trainers.events.resize ) );
        }
      },

      refresh: function () {
        var $slides = $( '.trainers-slides' );

        $slides.closest( '.caroufredsel_wrapper' ).height( '' );
        $slides.trigger( 'configuration', [ {}, true ] );
      },

      events: {
        resize: function () {
          Socjomania.helpers.afterRedraw( function () {
            Socjomania.trainers.refresh();
          } );
        }
      }
    },

    /**
     * Generic reveal/hide, expand/collapse functionality.
     * Just adds/removes 'open' class to/from target.
     */
    reveal: {
      init: function () {
        Socjomania.DOM.doc
            .off( '.reveal' )
            .on( (Modernizr.touch ? 'touchstart' : 'click') + '.reveal', '[data-toggle~="reveal"]', Socjomania.reveal.events.toggle );
      },

      events: {
        toggle: function ( ev ) {
          ev.preventDefault();

          var $target = $( Socjomania.helpers.getTarget( $( this ), 'reveal', this ) );
          var toggle;

          if ( ($( this ).data( 'reveal-state' ) || '').toLowerCase() === 'open' ) {
            toggle = true;
          }

          $target.toggleClass( 'open', toggle );
        }
      }
    },

    /**
     * Footer uncovering.
     */
    uncover: {
      skrollr: null,
      target: '#boxes',

      init: function () {
        if ( $( Socjomania.uncover.target ).length && !Modernizr.touch ) {
          Socjomania.uncover.refresh( true );
        }
      },

      refresh: function ( init ) {
        var $toUncover = $( Socjomania.uncover.target );
        var $content = $( '#content' );
        var $footer = $( '#footer' );
        var ch, fh;

        if ( $toUncover.length && !Modernizr.touch ) {
          fh = $footer.outerHeight();
          ch = $toUncover.outerHeight() + fh;

          $content.css( 'margin-bottom', ch );
          $toUncover.css( {
            bottom: fh
          } );

          if ( init ) {
            $toUncover.css( {
              position: 'fixed',
              left: 0,
              right: 0
            } );

            $footer.css( {
              position: 'fixed',
              left: 0,
              right: 0,
              bottom: 0
            } );

            Socjomania.DOM.win
                .off( '.uncover' )
                .on( 'resize.uncover', $.debounce( 100, Socjomania.uncover.events.resize ) );
          }
        }
      },

      events: {
        resize: function () {
          Socjomania.uncover.refresh();
        }
      }
    },

    /**
     * Generic scroll-to functionality.
     */
    scrollTo: {
      init: function () {
        Socjomania.DOM.doc
            .off( '.scrollto' )
            .on( (Modernizr.touch ? 'touchstart' : 'click') + '.scrollto', '[data-toggle~="scroll-to"]', Socjomania.scrollTo.events.click );
      },

      events: {
        click: function ( ev ) {
          ev.preventDefault();

          var $target = $( $( Socjomania.helpers.getTarget( $( this ), 'scroll-to', this.hash ) ) );
          var hash = $target.attr( 'id' );
          var top = $target.offset().top;

          if ( !Modernizr.touch ) {
            $( 'html, body' ).animate( {
              scrollTop: top - $( '#header' ).outerHeight()
            }, function () {
              window.location.hash = hash;
            } );
          } else {
            Socjomania.DOM.win.scrollTop( top - $( '#header' ).outerHeight() );
            window.location.hash = hash;
          }
        }
      }
    },

    /**
     * Sticky links for main page categories.
     */
    stickyLinks: {
      containerSelector: '.links',

      init: function () {
        var $links = $( Socjomania.stickyLinks.containerSelector );

        if ( $links.length ) {
          $links.clone().appendTo( '#header' ).addClass( 'hidden' );

          if ( !Modernizr.touch ) {
            Socjomania.DOM.win
                .off( '.stickylinks' )
                .on( 'scroll.stickylinks', Socjomania.stickyLinks.events.scroll )
                .on( 'resize.stickylinks', $.debounce( 100, Socjomania.stickyLinks.events.resize ) )
                .trigger( 'scroll.stickylinks' );
          } else {
            Socjomania.stickyLinks.events.redraw();
          }
        }
      },

      events: {
        scroll: function () {
          var $header = $( '#header' );
          var $bodyBag = $( '.body-bag' );
          var $links = $bodyBag.find( Socjomania.stickyLinks.containerSelector );
          var toggle = Socjomania.DOM.win.scrollTop() < $links.offset().top - $header.outerHeight();

          if ( $links.hasClass( 'hidden' ) === toggle ) {
            $header.find( Socjomania.stickyLinks.containerSelector ).transitionHelper().toggleClass( 'hidden', toggle );
            $links.toggleClass( 'hidden', !toggle );
          }
        },

        redraw: function () {
          Socjomania.stickyLinks.events.scroll();
          window.requestAnimationFrame( Socjomania.stickyLinks.events.redraw );
        },

        resize: function () {
          $( '.links' ).transitionHelper( null, true );
          Socjomania.stickyLinks.events.scroll();
        }
      }
    },

    autoScroll: {
      cookieName: 'socjomania-autoscroll',

      init: function () {
        Socjomania.DOM.doc
            .off( '.autoscroll' )
            .on( 'click.autoscroll', '.switch a', Socjomania.autoScroll.events.click );

        if ( $.cookie( Socjomania.autoScroll.cookieName ) ) {
          var $target = $( $.cookie( Socjomania.autoScroll.cookieName ) );

          $.removeCookie( Socjomania.autoScroll.cookieName, {
            path: '/'
          } );

          if ( $target.length ) {
            if ( !Modernizr.touch ) {
              $( 'html, body' ).animate( {
                scrollTop: $target.offset().top - $( '#header' ).outerHeight()
              } );
            } else {
              Socjomania.DOM.win.scrollTop( $target.offset().top - $( '#header' ).outerHeight() );
            }
          }
        }
      },

      events: {
        click: function () {
          var target = '#' + $( this ).closest( '.switch' ).get( 0 ).id;

          $.cookie( Socjomania.autoScroll.cookieName, target, {
            path: '/'
          } );
        }
      }
    },

    yourTopic: {
      init: function () {
        // fake link from Courses overview grid, since it would be hard
        // to actually include it in CMS
        $( '[class*="grid"] .color' ).closest( 'li' ).css( {
          cursor: 'pointer'
        } ).attr( 'data-toggle', 'scroll-to' ).attr( 'data-target', '#form' );
      }
    },

    underline: {
      init: function () {
        Socjomania.DOM.win
            .off( '.underline' )
            .on( 'resize.underline', $.debounce( 100, Socjomania.underline.events.resize ) )
            .trigger( 'resize.underline' );
      },

      events: {
        resize: function () {
          $( '.underline' ).css( {
            width: '',
            display: ''
          } ).each( function () {
            $( this ).width( $( this ).width() + 2 ).css( 'display', 'block' );
          } );
        }
      }
    },

    courseTopBar: {
      containerSelector: '#coursetopbar',

      init: function () {
        var $bar = $( Socjomania.courseTopBar.containerSelector );

        if ( $bar.length ) {
          $bar.find( '.menu-button' ).replaceWith( $( '#header' ).find( Socjomania.menu.containerSelector ).clone().attr( 'id', 'coursetopbarmenu' ) );

          if ( !Modernizr.touch ) {
            Socjomania.DOM.win
                .off( '.coursetopbar' )
                .on( 'scroll.coursetopbar', Socjomania.courseTopBar.events.scroll )
                .on( 'resize.coursetopbar', $.debounce( 100, Socjomania.courseTopBar.events.resize ) )
                .trigger( 'scroll.coursetopbar' );
          } else {
            Socjomania.courseTopBar.events.redraw();
          }
        }
      },

      events: {
        scroll: function () {
          var $after = $( '.courseplaces' );
          var $bar = $( Socjomania.courseTopBar.containerSelector );
          var toggle = Socjomania.DOM.win.scrollTop() > $after.outerHeight() + $after.offset().top - $bar.outerHeight();

          if ( $bar.hasClass( 'visible' ) !== toggle ) {
            $bar.transitionHelper().toggleClass( 'visible', toggle );
          }
        },

        redraw: function () {
          Socjomania.courseTopBar.events.scroll();
          window.requestAnimationFrame( Socjomania.courseTopBar.events.redraw );
        },

        resize: function () {
          $( Socjomania.courseTopBar.containerSelector ).transitionHelper( null, true );
          Socjomania.courseTopBar.events.scroll();
        }
      }
    },

    exitPopup: {
      containerSelector: '#exit-popup',
      cookieName: 'socjomania-exitpopup',

      init: function () {
        if ( window.ExitPopupConfig === undefined || $.cookie( Socjomania.exitPopup.cookieName ) ) {
          return;
        }

        Socjomania.exitPopup.activationPossible = false;

        Socjomania.DOM.win
            .off( '.exitpopup' )
            .on( 'resize.exitpopup orientationchange.exitpopup', Socjomania.exitPopup.events.resize )
            .trigger( 'resize.exitpopup' );

        if ( !Modernizr.touch ) {
          Socjomania.DOM.win
              .on( 'scroll.exitpopup', Socjomania.exitPopup.events.scroll )
              .trigger( 'scroll.exitpopup' );
        } else {
          Socjomania.courseTopBar.events.redraw();
        }
      },

      check: function () {
        var now = (new Date()).getTime();
        var scroll = Socjomania.DOM.win.scrollTop();
        var diff = Socjomania.exitPopup.lastOffset.scrollTop - scroll;

        if ( now - Socjomania.exitPopup.lastOffset.timestamp > ExitPopupConfig.scrollTime ) {
          Socjomania.exitPopup.lastOffset = false;

          if ( scroll === 0 || (diff >= Socjomania.exitPopup.viewportHeight * ExitPopupConfig.screensToScroll) ) {
            Socjomania.exitPopup.show();
          }
        }
      },

      show: function () {
        var $popup = $( Socjomania.exitPopup.containerSelector ).transitionHelper();

        $popup.on( 'click.exitpopup', '[data-toggle="exit"]', Socjomania.exitPopup.events.close );

        if ( ExitPopupConfig.expiryDays > -1 ) {
          $.cookie( Socjomania.exitPopup.cookieName, true, {
            path: '/',
            expires: ExitPopupConfig.expiryDays > 0 ? ExitPopupConfig.expiryDays : undefined
          } );
        }

        Socjomania.helpers.afterRedraw( function () {
          var $inner = $popup.children().eq( 0 );
          var m = Math.max( 0, (Socjomania.exitPopup.viewportHeight - $inner.outerHeight() - $popup.outerHeight() + $popup.height()) / 2 );
          $inner.css( {
            marginTop: m,
            marginBottom: m
          } );
          $popup.addClass( 'visible' );
        } );
      },

      events: {
        scroll: function () {
          var scroll = Socjomania.DOM.win.scrollTop();

          Socjomania.exitPopup.activationPossible |= scroll >= Socjomania.exitPopup.activationOffset;

          if ( Socjomania.exitPopup.activationPossible ) {
            clearTimeout( Socjomania.exitPopup.to );

            if ( !Socjomania.exitPopup.lastOffset ) {
              Socjomania.exitPopup.lastOffset = {
                scrollTop: scroll,
                timestamp: (new Date()).getTime()
              };
            }

            Socjomania.exitPopup.to = setTimeout( Socjomania.exitPopup.check, 100 );
          }
        },

        redraw: function () {
          if ( !Socjomania.exitPopup.removed ) {
            var scroll = Socjomania.DOM.win.scrollTop();
            if ( Socjomania.exitPopup.lastRedrawOffset !== scroll ) {
              Socjomania.exitPopup.events.scroll();
            }
            Socjomania.exitPopup.lastRedrawOffset = scroll;
            window.requestAnimationFrame( Socjomania.exitPopup.events.redraw );
          }
        },

        resize: function () {
          var $section = $();
          var sections = ExitPopupConfig.sectionSelector.split( ',' );
          var i = 0;
          while ( !$section.length ) {
            $section = $( sections[ i ] );
            i++;
          }
          Socjomania.exitPopup.viewportHeight = Socjomania.DOM.win.height();
          Socjomania.exitPopup.activationOffset = $section.offset().top + $section.outerHeight() - Socjomania.exitPopup.viewportHeight;
        },

        close: function () {
          var $popup = $( this ).closest( '.exit-popup' );
          $popup.transitionHelper( function () {
            $popup.remove();
            Socjomania.exitPopup.removed = true;
            Socjomania.DOM.win.off( '.exitpopup' );
          } ).removeClass( 'visible' );
        }
      }
    },

    blog: {
      init: function () {

        Socjomania.blog.showSocial();

        Socjomania.blog.rotateExpandIcon();

      },


      showSocial: function () {

        $( '#content' ).on( 'click', '.itemheader-social', function ( e ) {
          $( '.flyer' ).not( $( this ).next( '.flyer' ) ).addClass( 'hide' );
          $( this ).next( '.flyer' ).toggleClass( 'hide' );
          e.preventDefault();
        } );

        $( '.itemheader-social-mobile' ).on( 'click', function ( e ) {
          $( this ).next( '.flyer-mobile' ).toggleClass( 'hide' );
          e.preventDefault();


        } );


      },
      rotateExpandIcon: function () {
        var $toggleIcon = $( '.tags-icon' );
        //var $toggleHeader = $( '.tags > h2' );
        var $tags = $( '#tags' );

        $toggleIcon.on( 'click', function () {
          if ( parseInt( $tags.css( 'max-height' ) ) < 100 && !$toggleIcon.hasClass( 'open' ) ) {
            $toggleIcon.addClass( 'open' );
            $tags.addClass( 'open' );
          } else {
            $tags.removeClass( 'open' );
            $toggleIcon.removeClass( 'open' );

          }

        } );
      }


    }
  };

  $( function () {
    Socjomania.init();

    // invoke JS from socjomania2014.js
    window.domReady();
  } );

  $( window ).on( 'load', Socjomania.helpers.afterLoad );

  // in case page is loading a lot of time
  setTimeout( Socjomania.helpers.afterLoad, 1500 );
}( jQuery ));
